module.exports = __webpack_public_path__ + "static/media/bg-bottom-header.acdee0ce.svg";